import { Subscription } from 'rxjs';

import { IDisposable } from './disposable.interface';
import { tryUnsubscribe } from './try-unsubscribe.function';

export class SubscriptionManager implements Map<string, Subscription>, IDisposable {
  private readonly subscriptions = new Map<string, Subscription>();

  readonly [Symbol.toStringTag]: string = this.subscriptions[Symbol.toStringTag];

  [Symbol.iterator](): IterableIterator<[string, Subscription]> {
    return this.subscriptions[Symbol.iterator]();
  }

  get size() {
    return this.subscriptions.size;
  }

  clear() {
    for (const [_key, subscription] of this.subscriptions) {
      tryUnsubscribe(subscription);
    }

    this.subscriptions.clear();
  }

  delete(key: string) {
    if (!this.has(key)) {
      return false;
    }

    const subscription = this.get(key);
    tryUnsubscribe(subscription);

    return this.subscriptions.delete(key);
  }

  dispose() {
    this.clear();
  }

  entries() {
    return this.subscriptions.entries();
  }

  forEach(callbackFn: (value: Subscription, key: string, map: Map<string, Subscription>) => void, thisArg?: any) {
    this.subscriptions.forEach(callbackFn, thisArg);
  }

  get(key: string) {
    return this.subscriptions.get(key);
  }

  has(key: string) {
    return this.subscriptions.has(key);
  }

  keys() {
    return this.subscriptions.keys();
  }

  set(key: string, subscription: Subscription) {
    this.delete(key);

    this.subscriptions.set(key, subscription);

    return this;
  }

  values() {
    return this.subscriptions.values();
  }
}
